import React, {FC, useState} from "react"
import {Tab, Stack} from "@mui/material";
import Box from "@mui/material/Box";
import TabPanel from '@mui/lab/TabPanel';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import {ResultWrapper} from "@/widget/ResultWrapper/ResultWrapper";
import isEmpty from "lodash/isEmpty";
import {useQueryContract} from "@/service/contract.s";
import {ContractDetail} from "@/widget/CommonDetail/ContractDetail";
import {ServeTable} from "@/widget/CommonDetail/ServeTable";
import {ContractFiles} from "@/widget/CommonDetail/ContractFiles";
import {PaybackTable} from "@/widget/CommonDetail/PaybackTable";
import {InvoiceTable} from "@/widget/CommonDetail/InvoiceTable";
import {ChanceTable} from "@/widget/CommonDetail/ChanceTable";
import {ModeType, useDialogModal, useDrawerModal} from "@/store/global.c";
import {checkQueryKey, getRealId} from "@/helper/method";
import {ContactDetail} from "@/widget/CommonDetail/PaybackDetail";

interface ViewContractProps {
    mode: ModeType
}

export const ViewContract: FC<ViewContractProps> = ({mode}) => {
    const {id: drawerId} = useDrawerModal()
    const {id: dialogId} = useDialogModal()
    const id = getRealId(mode, drawerId, dialogId)
    const {data: contractData, isLoading: contractLoading} = useQueryContract({id}, checkQueryKey(id))
    const [tab, setTab] = useState<number>(1)
    const contract = contractData?.data
    return <><ResultWrapper isLoading={contractLoading} isEmpty={isEmpty(contract)}>
        <Stack direction={'column'} gap={2}>
            <ContractDetail data={contract} full={true}/>
            <TabContext value={tab}>
                <Stack direction="column" spacing={2}>
                    <Box sx={{borderBottom: 1, borderTop: 1, pt: 1, borderColor: 'divider'}}>
                        <TabList variant={'fullWidth'} onChange={(event, value) => setTab(value)}>
                            <Tab label="服务" value={1}/>
                            <Tab label="文件" value={2}/>
                            <Tab label="对接人" value={6}/>
                            <Tab label="回款" value={3}/>
                            <Tab label="开票" value={4}/>
                            <Tab label="商机" value={5}/>
                        </TabList>
                    </Box>
                    <TabPanel value={1} sx={{mt: 1, p: 0}}>
                        <ServeTable products={contract?.products}/>
                    </TabPanel>
                    <TabPanel value={2} sx={{p: 0}}>
                        <ContractFiles contractId={id}/>
                    </TabPanel>
                    <TabPanel value={3} sx={{p: 0}}>
                        <PaybackTable enabled={false} data={contract?.paybacks}/>
                    </TabPanel>
                    <TabPanel value={4} sx={{p: 0}}>
                        <InvoiceTable data={contract?.invoices} contractId={contract?.id}/>
                    </TabPanel>
                    <TabPanel value={5} sx={{p: 0}}>
                        <ChanceTable contractId={contract?.id}/>
                    </TabPanel>
                    <TabPanel value={6} sx={{p: 0}}>
                        <ContactDetail id={contract?.contactId}/>
                    </TabPanel>
                </Stack>
            </TabContext>
        </Stack>
    </ResultWrapper>

    </>
};


